import { useCallback } from 'react'

import { useSidePanelStore } from '#/shared/lib/side-panel'

import { useOpenConversation } from './use-open-conversation'
import type { OpenConversationTarget } from './use-open-conversation'

/**
 * Console twin of the product's `useOpenThread`.
 *
 * The product first tries the agent's browser-extension phone and falls back to
 * the site's panel. The console has no extension phone — an operator is not an
 * agent with a line — so only the panel branch is kept: open the panel and
 * point it at the thread. Same export, same signature, so the vendored campaign
 * pages stay verbatim copies.
 */
export function useOpenThread(): (
  target: OpenConversationTarget & { phone: string },
) => void {
  const openPanel = useSidePanelStore((s) => s.open)
  const openConversation = useOpenConversation()
  return useCallback(
    (target) => {
      openPanel()
      openConversation(target)
    },
    [openPanel, openConversation],
  )
}
